import BouncingSpinner from 'components/BouncingSpinner';
import Download from 'components/Icons/Download';
import React, { useState } from 'react';
import { SheetVersion } from 'records/SheetVersion';
import { getSheetPDF } from 'services/sheetService';
import { downloadFileWithAnchor, getDateString } from 'utils/general';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  sheetVersion: SheetVersion;
}

const ViewerFooterDownload: React.FC<Props> = (props) => {
  const [downloading, setDownloading] = useState<boolean>(false);
  const { translate } = useTranslator(['buttons']);

  const handleDownloadClick = (): void => {
    downloadSheetPDF();
  };

  const downloadSheetPDF = async (): Promise<void> => {
    try {
      setDownloading(true);
      const { pageid, projectid, documentid, sheetnumber, sheettitle } =
        props.sheetVersion;

      const url = await getSheetPDF(projectid, pageid, documentid);

      const filename = `${sheetnumber} - ${sheettitle} ${getDateString()}.pdf`;

      await downloadFileWithAnchor(url, filename);
    } catch (err) {
      console.log('ViewerFooterDownload::downloadSheetPDF Error', err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div id="viewer-footer-download">
      {downloading ? (
        <div className="flex-center mt1 mr4">
          <BouncingSpinner />
        </div>
      ) : (
        <button
          id="viewer-footer-download-download-btn"
          className="btn-sm btn-link-primary row items-center justify-between mr2"
          onClick={handleDownloadClick}
        >
          <div className="mr2">
            <Download width="14px" height="12px" />
          </div>
          <div className="font-size-4">{translate('buttons:download')}</div>
        </button>
      )}
    </div>
  );
};

export default ViewerFooterDownload;
